export default __webpack_public_path__ + "static/media/book12.19d9c6d8.svg";